export default __webpack_public_path__ + "static/media/payment-icon.ce188533.png";